import React, { useEffect } from 'react';
import { Camera } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth.js';

export const Login = () => {
  const { signInWithGoogle, loading, error, user } = useAuth();

  // Efecto para debugging - ver cuando cambia el usuario
  useEffect(() => {
    console.log('Login component - user state changed:', user);
  }, [user]);

  const handleGoogleSignIn = async () => {
    try {
      console.log('Attempting Google sign-in...');
      await signInWithGoogle();
      console.log('Google sign-in successful');
    } catch (error) {
      console.error('Google sign-in failed:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-indigo-100">
            <Camera className="h-8 w-8 text-indigo-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            MuchPic Admin
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Inicia sesión en tu panel de administración
          </p>
        </div>
        
        <div className="mt-8 space-y-6">
          {/* Botón de Google */}
          <div>
            <button
              type="button"
              onClick={handleGoogleSignIn}
              disabled={loading}
              className="group relative w-full flex justify-center py-3 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              {loading ? 'Conectando...' : 'Continuar con Google'}
            </button>
          </div>
          <p className="mt-4 text-center text-xs text-gray-500">
            Al continuar aceptas nuestros{' '}
            <a href="https://muchpic.com/terms.html" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-700">Términos y Condiciones</a>{' '}y la{' '}
            <a href="https://muchpic.com/privacy.html" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-700">Política de Privacidad</a>.
          </p>
          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">
                    Error de autenticación
                  </h3>
                  <div className="mt-2 text-sm text-red-700">
                    {error}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
